import { render, staticRenderFns } from "./ExternalChat.vue?vue&type=template&id=600312ae&scoped=true&"
import script from "./ExternalChat.vue?vue&type=script&lang=ts&"
export * from "./ExternalChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600312ae",
  null
  
)

export default component.exports